import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './baseQuery';

export interface IUserPoint {
  id: string;
  mail: string;
  tel: string;
  member_type: string;
  app_user_id: string;
  device_id: string;
  name: string;
  birthday: string;
  gender: number;
  address: number;
  job: number;
  hobby: string;
  active_at: string;
  rest_point: number;
  users_activate_flag: string;
  suspended_flag: number;
  point_get_rows_point_get_at: string;
  created_at: string;
}

export interface TotalPoint {
  users_total_number: number;
}

export const userPointApi = createApi({
  reducerPath: 'userPoint_api',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['userPoints', 'total', 'userStatus'],
  endpoints: build => ({
    getUserPoints: build.query<{ data: IUserPoint[]; total: number }, string>({
      query: params => ({
        url: `/point_get_rows${params && '?' + params}`,
        method: 'GET',
      }),
      providesTags: ['userPoints'],
      transformResponse: (response: {
        points_held_by_each_user: IUserPoint[];
        users_total_number: number;
      }) => ({
        data: response.points_held_by_each_user,
        total: response.users_total_number,
      }),
    }),
    getTotal: build.query<TotalPoint, string>({
      query: () => ({
        url: `/point_get_rows`,
        method: 'GET',
      }),
      providesTags: ['total'],
      transformResponse: (response: { users_total_number: TotalPoint }) =>
        response.users_total_number,
    }),
    updateUser: build.mutation<any, any>({
      query({ id, body }) {
        return {
          url: `/update_user/${id}`,
          method: 'PUT',
          data: body,
        };
      },
      invalidatesTags: ['userPoints'],
    }),
    changeUserStatus: build.mutation({
      query: ({id, body}) => ({
        url: `/point_get_rows/user/${id}`,
        method: 'PUT',
        data: body,
      }),
    }),
    permanentDeleteUser: build.mutation<any, { id: string; body: { uid: string; confirm_phrase: string } }>({
      query: ({ id, body }) => ({
        url: `/users/${id}/permanent_delete`,
        method: 'POST',
        data: body,
      }),
      invalidatesTags: ['userPoints', 'total'],
    }),
  }),
});

export const {
  useGetUserPointsQuery,
  useGetTotalQuery,
  useUpdateUserMutation,
  useChangeUserStatusMutation,
  usePermanentDeleteUserMutation,
} = userPointApi;
